import React from "react"
import { Redirect } from "@reach/router"

const Index = () => (
  <Redirect noThrow to={"/docs/"}/>
)

export default Index
